import React, { Component } from 'react';
import Helping from "../../helpers/Helping";
import Notification from "../layout/Notification";
import { setErrorFields, validateField } from "../../helpers/validationHelpers";
import route from '../../config/routes';
import { MESSAGE, ROLE, ROUTE_ACCESS, NODE_ENV } from '../../config/index';
import { setProfileError, addCurrentRoute } from '../../actions/profile_action';
import { API_URL } from '../../config/urls';
import Service from '../../helpers/service';
import { connect } from 'react-redux';
import { trackPromise } from 'react-promise-tracker';
import LoadingButton from '../fields/LoadingButton';

const { EMPTY, RESERVE, UPDATE, GREAT, LESS } = MESSAGE;
class Create extends Component {
    constructor(props) {
        super(props);
        this.state = {
            items: [],
            transaction_hash: [{ start: "", end: "", transactionHash: "", which_bc: "" }],
            url: API_URL.ADMIN_TRADING_API + route.NFT_RELEASE,
            routeName: route.RESERVE_NFT,
            blockchain: '',
            error_message: '',
            start_limit: 0,
            end_limit: 0,
            slot: '',
            code: '',
            slotsInfo: '',
            error_type: '',
            isLoading: true,
            btnIsDisable: false,
            btnIsEnable: true
        };

        this.onSave = this.onSave.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        this.setState({ isLoading: false });
        this.props.addCurrentRoute(this.props.profile, this.props.location.pathname);
    }

    async handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });

        if (name === "slot") this.setState({ ...await validateField("numeric", name, value, "", 3, "reserve slot") });
        if (name === "blockchain") this.setState({ ...await validateField("string", name, value, "", "", "blockchain") });
        if (name === "code") this.setState({ ...await validateField("string", name, value, "", "", "code") });
    }

    handleTransactionHashUpdate = async (e, index) => {
        const start_limit = {
            name: 'end range',
            value: this.state.transaction_hash[index].end.length > 0 ? this.state.transaction_hash[index].end : 0,
            check: LESS,
        },
            end_limit = {
                name: 'start range',
                value: this.state.transaction_hash[index].start.length > 0 ? this.state.transaction_hash[index].start : 0,
                check: GREAT,
            };
        const { name, value } = e.target;
        let result = this.state.transaction_hash;

        if (name === "start") {
            if (start_limit.value > 0) {
                result[index] = {
                    ...result[index], ...await validateField("numeric", name, value, "", 1, "range start", start_limit, true), [name]: Number(value)
                };
            }
            else {
                result[index] = {
                    ...result[index], ...await validateField("numeric", name, value, "", 1, "range"), [name]: Number(value)
                };
            }

        }
        if (name === "end") {
            if (end_limit.value > 0) {
                result[index] = {
                    ...result[index], ...await validateField("numeric", name, value, "", 1, "range end", end_limit, true), [name]: Number(value)
                };
            }
            else {
                result[index] = {
                    ...result[index], ...await validateField("numeric", name, value, "", 1, "range"), [name]: Number(value)
                };
            }

        }
        if (name === "transactionHash") {
            result[index] = { ...result[index], ...await validateField("string", name, value, "", 3, "transaction hash"), [name]: value };
        }
        if (name === "blockchain") {
            result[index] = { ...result[index], ...await validateField("string", name, value, "", 5, "blockchain"), ["which_bc"]: value };
        }
        this.setState({ transaction_hash: result });
        console.log(result);
    }

    setErrorOnApiCall = () => {
        setProfileError(res => this.setState({ ...res }));
    }

    removeNetworkError = () => {
        this.setState({ ...Helping.clearNetworkRequest() });
    }

    checkEmptyFieldsInTransactionHash = () => {
        let formHasError = false;
        let currentError = {};

        this.state.transaction_hash.map((currentHash, index) => {
            Helping.removeKeysFromObject(currentHash, ['error_message', "error_end", "error_end_message", "btnIsDisable", "error_start", "error_start_message", "error_type"])

            if (currentHash.start.length === 0) {
                let errorObject = setErrorFields("start", Helping.getMessageString(EMPTY, "range start"));
                currentError = { ...currentError, ...errorObject };
                formHasError = true;
            }
            if (currentHash.end.length === 0) {
                let errorObject = setErrorFields("end", Helping.getMessageString(EMPTY, "range end"));
                currentError = { ...currentError, ...errorObject };
                formHasError = true;
            }
            if (currentHash.transactionHash.length === 0) {
                let errorObject = setErrorFields("transactionHash", Helping.getMessageString(EMPTY, "transaction hash"));
                currentError = { ...currentError, ...errorObject };
                formHasError = true;
            }
            if (currentHash.which_bc.length === 0) {
                let errorObject = setErrorFields("blockchain", Helping.getMessageString(EMPTY, "blockchain"));
                currentError = { ...currentError, ...errorObject };
                formHasError = true;
            }
            if (formHasError) {
                this.setState((previousState) => {
                    let updatedTransactionHash = [...previousState.transaction_hash]
                    updatedTransactionHash[index] = { ...updatedTransactionHash[index], ...currentError }
                    return {
                        transaction_hash: updatedTransactionHash
                    }
                })
            }
        })
        return formHasError;
    }

    checkEmptyFields = () => {
        let { state } = this,
            formHasError = false;

        if (state.slot.length === 0) {
            let errorObject = setErrorFields("slot", Helping.getMessageString(EMPTY, "reserve slot"));
            this.setState({ ...errorObject });
            formHasError = true;
        }
        if (state.blockchain.length === 0) {
            let errorObject = setErrorFields("blockchain", Helping.getMessageString(EMPTY, "blockchain"));
            this.setState({ ...errorObject });
            formHasError = true;
        }
        return formHasError;
    }

    onSave(e) {
        e.preventDefault();

        let $this = this;
        let formHasError = this.checkEmptyFields();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsEnable: false,
            error_message: "",
            error_type: ""
        });

        let data = {
            action: 'reserve-nfts-slot',
            number_of_slot: $this.state.slot,
            which_bc: $this.state.blockchain
        };

        Service.postCall(this.state.url, data).then(response => {
            if (response.data.status === 200) {
                this.setState({
                    error_message: Helping.getMessageString(RESERVE, `${this.state.blockchain} NFTs`) + ` And ${response.data.payload.range} is the range for them.`,
                    error_type: "success",
                    btnIsEnable: true,
                }, () => { this.scrollToTop(); this.resetSlotsForm() });
            }
        }).catch(error => {
            if (error.response) {
                Helping.redirectToLogin(error);
                return $this.setState({
                    error_message: error.response.data.message,
                    error_type: 'danger',
                    btnIsEnable: true,
                }, () => { this.scrollToTop(); });
            }
            return this.setState({
                isLoading: false,
                btnIsEnable: true,
                ...Helping.setNetworkRequestError(error, "reserving nft")
            }, () => { this.scrollToTop(); });
        });
    }

    onTransactionHashUpdate = (e) => {
        e.preventDefault();

        let $this = this;
        let formHasError = this.checkEmptyFieldsInTransactionHash();
        if (formHasError) {
            window.scrollToErrorFields();
            return;
        }

        this.setState({
            btnIsDisable: true,
            error_message: "",
            error_type: ""
        });

        let data = {
            action: 'update-transactionHash-with-range',
            data: this.state.transaction_hash
        };

        Service.postCall(API_URL.ADMIN_TRADING_API + route.NFT_RELEASE, data).then(response => {
            if (response.data.status === 200) {
                this.setState(
                    {
                        error_message: Helping.getMessageString(UPDATE, "transaction hash"),
                        error_type: "success",
                        btnIsDisable: false
                    }, () => { this.scrollToTop(); this.resetHashForm() }
                );
            }
        }).catch(error => {
            if (error.response) {
                Helping.redirectToLogin(error);
                return $this.setState({
                    error_message: error.response.data.message,
                    error_type: 'danger',
                    btnIsDisable: false
                }, () => { this.scrollToTop(); });
            }
            return this.setState({
                isLoading: false,
                btnIsDisable: false,
                ...Helping.setNetworkRequestError(error, "transaction hash")
            }, () => { this.scrollToTop(); });
        });
    }

    showToast = () => {
        window.$(".toast").addClass("slide");
    }

    hideToast = () => {
        window.$(".toast").removeClass("slide");
    }

    getReserverSlotWithoutTransactionHash = (e) => {
        e.preventDefault();
        var $this = this;

        trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + route.NFT_RELEASE, {
                action: 'reserved-slot-without-transaction-hash',
                is_data: 1
            })
                .then((response) => {
                    const { matic, eth, tezos } = response.data.payload;
                    $this.setState({
                        slotsInfo: `<li><label>MATIC:</label><span>${this.getRanges(matic, 'slots available')}.</span></li> <li><label>ETH:</label><span>${this.getRanges(eth, 'slots available')}.</span></li><li><label>TEZOS:</label><span>${this.getRanges(tezos, 'slots available')}.</span></li>`,
                    },
                        () => this.showToast()
                    );

                })
                .catch((error) => {
                    console.error('in transaction without hash error: ', error);
                    if (error.response) {
                        Helping.redirectToLogin(error);
                        return this.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger',
                        });
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(error, 'reserve slot without transaction hash'),
                    });
                })
        )
    }

    getRanges = (data, txt) => {
        var ranges = [];
        var msg = "";

        if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
                msg += data[i].count + ', ';

                if (!data[i].range)
                    ranges.push(0);
                else
                    ranges.push(data[i].range);
            }
        }
        else {
            msg = '0 ';
            ranges.push(0);
        }

        msg = msg.replace(/,(\s+)?$/, ' ') + txt + " which ranges from ";

        for (var i = 0; i < ranges.length; i++) {
            msg += ranges[i] + ', ';
        }

        return msg.replace(/,(\s+)?$/, ' ');
    }

    getReserverSlotWithoutMetaData = (e) => {
        e.preventDefault();
        var $this = this;

        trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + route.NFT_RELEASE, {
                action: 'reserved-slot-without-transaction-hash',
                is_data: 0
            })
                .then((response) => {
                    const { matic, eth, tezos } = response.data.payload;

                    $this.setState({
                        slotsInfo: `<li><label>MATIC:</label><span>${this.getRanges(matic, 'slots available')}.</span></li><li><label>ETH:</label><span>${this.getRanges(eth, 'slots available')}.</span></li><li><label>TEZOS:</label><span>${this.getRanges(tezos, 'slots available')}.</span></li>`,
                    },
                        () => this.showToast());
                })
                .catch((error) => {
                    console.error('in transaction without metadata error: ', error);
                    if (error.response) {
                        Helping.redirectToLogin(error);
                        return this.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger',
                        });
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(error, 'reserve slot without metadata'),
                    });
                })
        )
    }

    getReserverSlotWithTransactionHash = (e) => {
        e.preventDefault();
        var $this = this;

        trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + route.NFT_RELEASE, {
                action: 'reserved-slot-with-transaction-hash',
                is_data: 0,
            })
                .then((response) => {
                    const { matic, eth, tezos } = response.data.payload;

                    $this.setState({
                        slotsInfo: `<li><label>MATIC:</label><span>${matic.count} slots available, which ranges from ${matic.range}.</span></li><li><label>ETH:</label><span>${eth.count} slots available, which ranges from ${eth.range}.</span></li><li><label>TEZOS:</label><span>${tezos.count} slots available, which ranges from ${tezos.range}.</span></li>`,
                    },
                        () => this.showToast());
                })
                .catch((error) => {
                    console.error('in transaction with transaction hash error: ', error);
                    if (error.response) {
                        Helping.redirectToLogin(error);
                        return this.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger',
                        });
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(
                            error,
                            'reserve slot with transaction hash'
                        ),
                    });
                })
        )
    }

    getReserverSlotWithTransactionHashWithMetaData = (e) => {
        e.preventDefault();
        var $this = this;

        trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + route.NFT_RELEASE, {
                action: 'reserved-slot-with-transaction-hash',
                is_data: 1,
            })
                .then((response) => {
                    const { matic, eth, tezos } = response.data.payload;

                    $this.setState({
                        slotsInfo: `<li><label>MATIC:</label><span>${matic.count} slots available, which ranges from ${matic.range}.</span></li><li><label>ETH:</label><span>${eth.count} slots available, which ranges from ${eth.range}.</span></li><li><label>TEZOS:</label><span>${tezos.count} slots available, which ranges from ${tezos.range}.</span></li>`,
                    }, () => this.showToast());
                })
                .catch((error) => {
                    console.error('in transaction with transaction hash error: ', error);
                    if (error.response) {
                        Helping.redirectToLogin(error);
                        return this.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger',
                        });
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(
                            error,
                            'reserve slot with transaction hash'
                        ),
                    });
                })
        )
    }

    getReleasedNfts = (e) => {
        e.preventDefault();
        var $this = this;

        trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + route.NFT_RELEASE, {
                action: 'nfts-meta-data-with-hash',
                is_release: 1,
            })
                .then((response) => {
                    const { matic, eth, tezos } = response.data.payload;

                    $this.setState({
                        slotsInfo: `<li><label>MATIC:</label><span>${matic.count} are released nfts, which ranges between ${matic.range}.</span></li><li><label>ETH:</label><span>${eth.count} are released nfts, which ranges between ${eth.range}.</span></li><li><label>TEZOS:</label><span>${tezos.count} are released nfts, which ranges between ${tezos.range}.</span></li>`,
                    },
                        () => this.showToast());
                })
                .catch((error) => {
                    console.error(
                        'in released nft slots error: ',
                        error
                    );
                    if (error.response) {
                        Helping.redirectToLogin(error);
                        return this.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger',
                        });
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(
                            error,
                            'released nft slots'
                        ),
                    });
                })
        )
    }

    getUnreleasedNfts = (e) => {
        e.preventDefault();
        var $this = this;

        trackPromise(
            Service.postCall(API_URL.ADMIN_TRADING_API + route.NFT_RELEASE, {
                action: 'nfts-meta-data-with-hash',
                is_release: 0,
            })
                .then((response) => {
                    const { matic, eth, tezos } = response.data.payload;

                    $this.setState({
                        slotsInfo: `<li><label>MATIC:</label><span>${matic.count} are unreleased nfts, which ranges between ${matic.range}.</span></li><li><label>ETH:</label><span>${eth.count} are unreleased nfts, which ranges between ${eth.range}.</span></li><li><label>TEZOS:</label><span>${tezos.count} are unreleased nfts, which ranges between ${tezos.range}.</span></li>`,
                    },
                        () => this.showToast());
                })
                .catch((error) => {
                    console.error(
                        'in unreleased nft slots error: ',
                        error
                    );
                    if (error.response) {
                        Helping.redirectToLogin(error);
                        return this.setState({
                            error_message: error.response.data.message,
                            error_type: 'danger',
                        });
                    }
                    return this.setState({
                        ...Helping.setNetworkRequestError(
                            error,
                            'unreleased nft slots'
                        ),
                    });
                })
        )
    }

    getUnreleasedChilds = (e) => {
        e.preventDefault();

        this.setState({
            btnIsDisable: true
        })

        var $this = this;
        Service.postCall(API_URL.ADMIN_TRADING_API + route.NFT_RELEASE, {
            action: 'get-nft-unrelease-child',
            code: this.state.code,
        })
            .then((response) => {
                const { matic, eth, tezos } = response.data.payload;

                $this.setState({
                    slotsInfo: `<li><label>MATIC:</label><span>${this.getRanges(matic, 'unreleased nft childs are found')}.</span></li><li><label>ETH:</label><span>${this.getRanges(eth, 'unreleased nft childs are found')}.</span></li><li><label>TEZOS:</label><span>${this.getRanges(tezos, 'unreleased nft childs are found')}.</span></li>`,
                    btnIsDisable: false
                },
                    () => { this.closeModal(); this.showToast(); });
            })
            .catch((error) => {
                console.error('in unreleased nfts child error: ', error);

                if (error.response) {
                    Helping.redirectToLogin(error);
                    return this.setState(
                        {
                            error_message: error.response.data.message,
                            error_type: 'danger',
                            btnIsDisable: false
                        },
                        () => { this.closeModal(); }
                    );
                }
                return this.setState(
                    {
                        ...Helping.setNetworkRequestError(
                            error,
                            'unreleased nfts child'
                        ),
                    },
                    () => { this.closeModal(); }
                );
            })

    }

    handleArrayRemove = (e, index) => {
        e.preventDefault();

        const result = Helping.removeArrayFromIndex(this.state.transaction_hash, index);
        this.setState({ transaction_hash: result })
    }

    handleAddElementInArray = (e) => {
        e.preventDefault();

        this.setState((previousState) => {
            return previousState.transaction_hash.push({ start: "", end: "", transactionHash: "", which_bc: "" });
        })
    }

    closeModal = () => {
        window.$('#unreleasedNFT').modal('hide');
    }

    scrollToTop = () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    resetSlotsForm = () => {
        this.setState({
            slot: "",
            blockchain: "",
            btnIsEnable: true,
            error_slot_message: "",
            error_blockchain_message: ""
        })
    }

    resetHashForm = () => {
        this.setState({
            transaction_hash: [{ start: "", end: "", transactionHash: "", which_bc: "" }],
            btnIsDisable: false
        })
    }

    render() {
        let role_access = {}, isAdmin = false;

        if (Object.keys(this.props.profile).length > 0) {
            role_access = JSON.parse(this.props.profile.role_access);
            isAdmin = role_access.role === ROLE.ADMIN.toLowerCase();
        }
        let writeAccess = isAdmin || (Object.keys(role_access).length > 0 && role_access.access && role_access.access[ROUTE_ACCESS.RESERVENFT.toLowerCase()].write);

        return (
            <>
                <div class="content reserveNFT-content">
                    <div class="top-header">
                        <div class="header-title">
                            <h2 class="title">Reserve NFT</h2>
                            <span class="title-caption">You can view your NFT status now.</span>
                        </div>
                        <div class="header-btn">
                            <button class="custom-btn dark-btn sm-btn" data-toggle="modal" data-target="#unreleasedNFT">Unreleased By Code</button>
                            <button class="custom-btn dark-btn sm-btn" onClick={(e) => this.getUnreleasedNfts(e)}>Unreleased NFTs</button>
                            <button class="custom-btn dark-btn sm-btn" onClick={(e) => this.getReleasedNfts(e)}>Released NFTs</button>
                            <button class="custom-btn dark-btn sm-btn" onClick={(e) => this.getReserverSlotWithTransactionHashWithMetaData(e)}>Slot with Metadata with Hash</button>
                            <button class="custom-btn dark-btn sm-btn" onClick={(e) => this.getReserverSlotWithTransactionHash(e)}>Slot without Metadata with Hash</button>
                            <button class="custom-btn dark-btn sm-btn" onClick={(e) => this.getReserverSlotWithoutMetaData(e)}>Slot without Metadata without Hash</button>
                            <button class="custom-btn dark-btn sm-btn" onClick={(e) => this.getReserverSlotWithoutTransactionHash(e)}>Slot with Metadata without Hash</button>
                        </div>
                    </div>
                    {this.state.error_message &&
                        <Notification
                            type={this.state.error_type}
                            message={this.state.error_message}
                            callback={this.removeNetworkError}
                        />
                    }

                    {writeAccess && (
                        <div class="main-content nft-form">
                            <form action="" class="reserveNFT-form">
                                <div class="form-group">
                                    <label for="reserveSlot">Slot</label>
                                    <input type="text" name="slot" id="reserveSlot" value={this.state.slot} class={`form-control ${this.state.error_slot_message ? 'error-input' : ''}`} onChange={(e) => this.handleChange(e)} />
                                    <span className="error-msg">{this.state.error_slot_message}</span>
                                </div>
                                <div class="form-group">
                                    <label for="reserveBlockchain">Blockchain</label>

                                    <select class="form-select" aria-label="Blockchain select example"
                                        name="blockchain" id="reserveBlockchain" value={this.state.blockchain}
                                        class={`form-select ${this.state.error_blockchain_message ? 'error-input' : ''}`}
                                        onChange={(e) => this.handleChange(e)}
                                    >
                                        <option value="" selected>Select Blockchain...</option>
                                        <option value="CARDANO">CARDANO</option>
                                        <option value="MATIC">MATIC</option>
                                        {NODE_ENV === 'DEV' &&
                                            <option value="TEZOS">TEZOS</option>
                                        }
                                        <option value="ETH">ETH</option>
                                    </select>
                                    <span className="error-msg">{this.state.error_blockchain_message}</span>
                                </div>

                                <div class="content-btn">
                                    <button type="reset" class="custom-btn sm-btn semi-dark-btn border-btn" onClick={this.resetSlotsForm}>Reset</button>
                                    {!this.state.btnIsEnable ?
                                        <LoadingButton class_name={"sm-btn"} />
                                        :
                                        <button type="submit" class="custom-btn sm-btn gradiant-btn" onClick={(e) => this.onSave(e)}>{!this.state.btnIsEnable ? "Loading..." : "Save"}</button>
                                    }
                                </div>
                            </form>
                            <form action="" class="transactionHash-form">
                                <h5 class="form-title">Update Transactions Hash from Range</h5>
                                <div class="form-caption">
                                    <label>Transactions Hash: </label>
                                    <button class="add-form" onClick={(e) => this.handleAddElementInArray(e)}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-plus"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                    </button>
                                </div>

                                {Array.isArray(this.state.transaction_hash) && this.state.transaction_hash.map((currentContent, index) => (
                                    <div class="">
                                        <button class="close-form" onClick={(e) => this.handleArrayRemove(e, index)}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-minus"><line x1="5" y1="12" x2="19" y2="12"></line></svg>
                                        </button>
                                        <div class="transactionHash">
                                            <div class="form-group">
                                                <label for="hashStart">Start</label>
                                                <input type="text" name="start" id="hashStart" value={currentContent.start} class={`form-control ${currentContent.error_start_message ? 'error-input' : ''}`} onChange={(e) => this.handleTransactionHashUpdate(e, index)} />
                                                <span className="error-msg">{currentContent.error_start_message}</span>
                                            </div>
                                            <div class="form-group">
                                                <label for="hashEnd">End</label>
                                                <input type="text" name="end" id="hashEnd" value={currentContent.end} class={`form-control ${currentContent.error_end_message ? 'error-input' : ''}`} onChange={(e) => this.handleTransactionHashUpdate(e, index)} />
                                                <span className="error-msg">{currentContent.error_end_message}</span>
                                            </div>
                                            <div class="form-group">
                                                <label for="transHash">Transactions Hash</label>
                                                <input type="text" name="transactionHash" id="transHash" value={currentContent.transactionHash} class={`form-control ${currentContent.error_transactionHash_message ? 'error-input' : ''}`} onChange={(e) => this.handleTransactionHashUpdate(e, index)} />
                                                <span className="error-msg">{currentContent.error_transactionHash_message}</span>
                                            </div>
                                            <div class="form-group">
                                                <label for="transBlockchain">Blockchain</label>
                                                <select class={`form-select ${currentContent.error_blockchain_message ? 'error-input' : ''}`} aria-label="Blockchain select example"
                                                    name="blockchain" id="transBlockchain" value={currentContent.blockchain}
                                                    onChange={(e) => this.handleTransactionHashUpdate(e, index)}
                                                >
                                                    <option value="" selected></option>
                                                    <option value="CARDANO">CARDANO</option>
                                                    <option value="MATIC">MATIC</option>
                                                    {NODE_ENV === 'DEV' &&
                                                        <option value="TEZOS">TEZOS</option>
                                                    }
                                                    <option value="ETH">ETH</option>
                                                </select>
                                                <span className="error-msg">{currentContent.error_blockchain_message}</span>
                                            </div>
                                        </div>
                                    </div>
                                )
                                )}
                                <div class="content-btn">
                                    <button type="reset" class="custom-btn sm-btn semi-dark-btn border-btn" onClick={this.resetHashForm}>Reset</button>
                                    {this.state.btnIsDisable ?
                                        <LoadingButton class_name={"sm-btn"} />
                                        :
                                        <button type="submit" class="custom-btn sm-btn gradiant-btn" onClick={(e) => this.onTransactionHashUpdate(e)}>{this.state.btnIsDisable ? "Loading..." : "Save"}</button>
                                    }
                                </div>
                            </form>
                        </div>
                    )}
                </div >

                {/* --- Toast ---- */}
                <div class="toast">
                    <div class="toast-header">
                        <div class="toast-title">
                            <svg id="info" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                                <path id="Path_394" data-name="Path 394" d="M11,2a9,9,0,1,0,9,9A9,9,0,0,0,11,2Zm0,1.8A7.2,7.2,0,1,1,3.8,11,7.2,7.2,0,0,1,11,3.8Z" transform="translate(-2 -2)" />
                                <g id="info-2" data-name="info" transform="translate(-444 -18)">
                                    <rect id="Rectangle_277" data-name="Rectangle 277" width="1.5" height="6" rx="0.75" transform="translate(452.5 25)" />
                                    <rect id="Rectangle_278" data-name="Rectangle 278" width="1.5" height="1.5" rx="0.75" transform="translate(452.5 22.5)" />
                                </g>
                            </svg>
                            <h5>Attention</h5>
                        </div>
                        <button class="close-toast" data-dismiss="toast" onClick={this.hideToast}>&times;</button>
                    </div>
                    <div class="toast-body">
                        <ul dangerouslySetInnerHTML={{ __html: this.state.slotsInfo }} />
                    </div>
                </div>

                {/* ---- Unrealeased NFTs Modal ---- */}
                < div class="actionModal modal fade" id="unreleasedNFT" tabindex="-1" role="dialog" aria-labelledby="unreleasedNFT" aria-hidden="true" >
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="">NFT Unreleased Child</h5>
                            </div>

                            <div class="modal-body">
                                <div class="form-group">
                                    <label for="unRelCode">Code: </label>
                                    <input type="text" name="code" class="form-control" value={this.state.code} id="unRelCode" onChange={(e) => this.handleChange(e)} />
                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="custom-btn sm-btn semi-dark-btn" data-dismiss="modal">Close</button>
                                {this.state.btnIsDisable ?
                                    <LoadingButton class_name={"sm-btn"} />
                                    :
                                    <button type="button" class="custom-btn sm-btn gradiant-btn" onClick={(e) => this.getUnreleasedChilds(e)}>{this.state.btnIsDisable ? "Loading..." : "Submit"}</button>
                                }
                            </div>
                        </div>
                    </div>
                </div >
            </>
        );
    }
}

const mapDispatchToProps = {
    addCurrentRoute
}

export default connect(null, mapDispatchToProps)(Create)